import axios from 'axios';
import { VueCookieNext } from 'vue-cookie-next'
import Logger from './Logger';
// import Logger from './Logger'
// import CommonUtil from './CommonUtil.js'

// axios.defaults.withCredentials = true; //yong-todo origin + auth NOT ALLOWED
//axios.defaults.baseURL = 'https://api.cafeknotted.com';
// axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
// axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
// axios.defaults.headers.common['Authorization'] = getToken()
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// ConfigAxios.initInterceptors(axios)

export default {
    instance() {
        return axios
    },

    headers() {
      let token = this.getToken()
    
      if (token) {
        return { 
            'X-Nominee-Token': token,
          };
      } else {
        return {};
      }
    },

    getToken() {
      this.token = VueCookieNext.getCookie('token') 
      Logger.debug("TOKEN GET - " + this.token)
      return this.token
    },

    setToken(token) {
      Logger.debug("TOKEN SET - " + token)

      this.token = token
      VueCookieNext.setCookie('token', token, {expire: "1d"})
    },

}